/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Steps_ThoughtInputs */



/**
* | output |
* | --- |
* | "Thought it through" |
*
* @param {Chat_Steps_ThoughtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_steps_thought = /** @type {((inputs?: Chat_Steps_ThoughtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Steps_ThoughtInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Habe nachgedacht")
	return /** @type {LocalizedString} */ ("Thought it through")
});